module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "login"
  }, [(!_vm.showSuccess) ? _c('section', {
    staticClass: "login__modal"
  }, [_c('h2', {
    staticClass: "login__title"
  }, [_vm._v(_vm._s(_vm.L.localize('Account_Breadcrumb_ForgotPassword')))]), _vm._v(" "), (!_vm.showSuccess) ? _c('form', {
    staticClass: "form js-form",
    attrs: {
      "data-form": "login"
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.send.apply(null, arguments)
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.send.apply(null, arguments)
      }
    }
  }, [(_vm.error) ? _c('span', {
    staticClass: "form__validation"
  }, [_vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('TextBox', {
    attrs: {
      "label": "Label_EmailAddress",
      "validate": _vm.$v,
      "autocomplete": "email",
      "placeholder": "Placeholder_Email",
      "modelPath": "email",
      "acc": "email"
    },
    on: {
      "input": _vm.$v.email.$touch
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('Btn', {
    attrs: {
      "isLoading": _vm.loading,
      "label": "Account_Breadcrumb_ResetPassword"
    },
    on: {
      "click": _vm.send
    }
  })], 1) : _vm._e()]) : _c('div', {
    staticClass: "login__modal"
  }, [_c('span', {
    staticClass: "form__success"
  }, [_vm._v("\n        " + _vm._s(_vm.L.localize("Account_ForgotPasswordConfirmation_Text")) + "\n      ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-380e5aba!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/account/ForgotPassword.vue
// module id = 724
// module chunks = 1